import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto';
import { IconButton } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import {
  GetPrintHeadingByIdQuery_query_printHeading_PrintHeading_assignments_Assignment,
  GetPrintHeadingByIdQuery_query_printHeading_PrintHeading_printTemplates_PrintHeadingPrintTemplate_printTemplate_PrintTemplate_articleTemplates_ArticleTemplate_assignments_Assignment,
} from '../../../__generated__/queries-topic';
import { TopicLink } from '../../../components/Link/TopicLink';
import { paths, replaceParams } from '../../../routing';
import { getColorByStatus } from '../../../utils/rawArticleStatus';
import { useStyles } from './styles';

interface SubjectAutoItemProps {
  assignment:
    | GetPrintHeadingByIdQuery_query_printHeading_PrintHeading_assignments_Assignment
    | GetPrintHeadingByIdQuery_query_printHeading_PrintHeading_printTemplates_PrintHeadingPrintTemplate_printTemplate_PrintTemplate_articleTemplates_ArticleTemplate_assignments_Assignment;
  isEmpty?: boolean;
}

export const SubjectAutoItem: FC<SubjectAutoItemProps> = ({
  assignment,
  isEmpty,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.paperWrapper}>
      <Paper elevation={4} className={classes.paper}>
        <Typography className={classes.title} variant="subtitle1">
          {assignment.subject.title}
        </Typography>
        <div className={classes.auto}>
          {!isEmpty && (
            <TopicLink
              to={{
                pathname: replaceParams(paths.ARTICLE_AUTO_EDIT, {
                  id: assignment?.rawArticle?.id || '',
                }),
              }}
            >
              <IconButton
                className={classes.assignmentButton}
                disabled={!assignment?.rawArticle}
                size="large"
              >
                <BrightnessAutoIcon
                  style={{
                    color: getColorByStatus(
                      assignment?.rawArticle?.lastVersion?.status,
                    ),
                  }}
                />
              </IconButton>
            </TopicLink>
          )}
        </div>
      </Paper>
    </div>
  );
};
